/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 29/07/2025.
 */
import { Button } from 'antd'
import { DrawerContainer } from '../../components/drawer/DrawerContainer'
import { DEVICE_STATE, DEVICE_STATE_TYPE } from '../../Types'
import React, { useState } from 'react'
import { COLOR } from '../../constants'
import { FormLabel } from '../../components/form/FormLabel'
import TextArea from 'antd/es/input/TextArea'
import { useParams } from 'react-router-dom'
import { ENDPOINTS } from '../../service/ENDPOINTS'
import { post } from '../../service/API'
import { useFadeIn } from '../../components/animation/useFadeIn'
import { InitiateDataSync } from './move/InitiateDataSync'
import { DEVICE_UNAVAILBLE_ROUTE } from '../../routes'

type Props = {
  projectStatus: string
  deviceState: DEVICE_STATE_TYPE
  showModalDeviceWipe: () => void
  deviceId?: string
  mutateSubjectData: () => void
}

export const SubjectReplaceDevice = ({
  projectStatus,
  deviceState,
  showModalDeviceWipe,
  deviceId,
  mutateSubjectData,
}: Props) => {
  const [state, setState] = useState(false)

  const [navigateTo, setNavigateTo] = useState('')

  if (
    deviceState === DEVICE_STATE.WIPE_DEVICE ||
    deviceState === DEVICE_STATE.WIPED ||
    deviceState === DEVICE_STATE.ENROLL_NEW_DEVICE
  ) {
    return null
  }

  const drawerStateChange = (value) => {
    setState(value)
  }

  const navigateToDeviceNotAvailble = () => {
    setNavigateTo(DEVICE_UNAVAILBLE_ROUTE.to)
    setState(false)
  }

  return (
    <div className="col-12 mt-4 px-4 py-4 rounded-3" style={{ background: COLOR.LIGHT_GRAY }}>
      <h5 className="mb-3 mt-1">Replace Device</h5>

      <p>
        Click <span className="fw-bold">Replace Device</span> to wipe the device, once completed it can be reassigned to
        a new subject. This action permanently deletes all data on the device, therefore a synchronization process shall
        be initiated to capture any pending data from the devices.
      </p>

      <Button
        onClick={() => {
          setState(!state)
        }}
        className="px-5 mt-3"
        size="large"
        danger
        disabled={projectStatus !== 'ACTIVE'}
      >
        Replace device
      </Button>

      <DrawerContainer
        projectId={'projectId'}
        open={state}
        setVisible={drawerStateChange}
        width={525}
        to={navigateTo}
        title=" "
      >
        <InitiateDataSync navigateToDeviceNotAvailble={navigateToDeviceNotAvailble}>
          <JustifyDeviceWipe
            deviceId={deviceId}
            onClose={() => {
              setState(false)
            }}
            mutateSubjectData={mutateSubjectData}
          ></JustifyDeviceWipe>
        </InitiateDataSync>
      </DrawerContainer>
    </div>
  )
}

const JustifyDeviceWipe = ({ onClose, deviceId, mutateSubjectData }) => {
  const { animated, spring } = useFadeIn()

  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }
  const [justification, setJustification] = useState<string>('')
  const [error, setError] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (error.length > 0) {
      setError('')
    }

    setJustification(e.target.value)
  }

  const confirmWipe = () => {
    if (isLoading) {
      return
    }

    if (!justification || justification.length < 3) {
      setError('Please provide a justification for this action')
      return null
    }

    setIsLoading(true)
    const obj = {
      projectId: projectId,
      subjectId: subjectId,
      deviceId: deviceId,
      reason: justification,
    }

    const path = ENDPOINTS.SUBJECTS.wipeDevice(projectId)
    post(path, obj)
      .then((res) => {
        setIsLoading(false)
        console.log('DeviceDetails > res = ', res)
        mutateSubjectData()
        //setShow(false)
      })
      .catch((err) => {
        setIsLoading(false)
        console.log('DeviceDetails > err = ', err)
        alert(err.message)
      })
  }

  return (
    <animated.div style={spring} className="">
      <div className="">
        <h4 className="mb-4 mt-2">Replace Device</h4>
        <p>
          Ready to proceed with device replacement. All study data has been synced and securely stored -{' '}
          <span className="fw-bold">no data loss will occur.</span>
        </p>
        <p className="mt-3">
          Replacing the device will remove the participant's access to this device and reset it for new enrolment.
        </p>
        <p className="mt-3 fw-bold">Once confirmed:</p>
        <p>- Continuing participants will need a new device to resume study</p>
        <p>- Device will be ready for a new participant</p>
      </div>

      <div className="mt-3">
        <FormLabel label="Provide justification"></FormLabel>
        <TextArea placeholder="Replace device reason" rows={2} className="" onChange={handleTextChange} />
        {error ? <p className="text-danger">{error}</p> : null}
      </div>

      <div className="d-flex justify-content-end mt-3">
        <div className="">
          <Button className="ms-2" type="default" onClick={onClose}>
            Cancel
          </Button>
          <Button className="ms-2" danger type="primary" onClick={confirmWipe} loading={isLoading}>
            Finalize replace device
          </Button>
        </div>
      </div>
    </animated.div>
  )
}
